<template>
  <form autocomplete="off">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content>
        <ValidationProvider
          name="startDate"
          :rules="{
            required: false,
            regex: /^([0-2]{1}[0-9]{1}|3[0-1]{1})-(0[0-9]{1}|1[0-2]{1})-20[0-9]{2}$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field
            class="md-datepicker"
            :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
            :disabled="requesting"
          >
            <label>Start datum</label>
            <md-datepicker
              v-model="startDate"
              name="startDate"
              id="startDate"
              :md-model-type="String"
              md-immediately
            />

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="stopDate"
          :rules="{
            required: false,
            regex: /^([0-2]{1}[0-9]{1}|3[0-1]{1})-(0[0-9]{1}|1[0-2]{1})-20[0-9]{2}$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field
            class="md-datepicker"
            :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
            :disabled="requesting"
          >
            <label>Stop datum</label>
            <md-datepicker
              v-model="stopDate"
              :md-model-type="String"
              md-immediately
            />

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <md-field>
          <div class="md-layout-item md-inline-checkboxes">
            <md-checkbox v-model="monday" :disabled="requesting"
              >Maandag</md-checkbox
            >
            <md-checkbox v-model="tuesday" :disabled="requesting"
              >Dinsdag</md-checkbox
            >
            <md-checkbox v-model="wednesday" :disabled="requesting"
              >Woensdag</md-checkbox
            >
            <md-checkbox v-model="thursday" :disabled="requesting"
              >Donderdag</md-checkbox
            >
            <md-checkbox v-model="friday" :disabled="requesting"
              >Vrijdag</md-checkbox
            >
            <md-checkbox v-model="saturday" :disabled="requesting"
              >Zaterdag</md-checkbox
            >
            <md-checkbox v-model="sunday" :disabled="requesting"
              >Zondag</md-checkbox
            >
          </div>
        </md-field>
      </md-card-content>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
          >Terug</md-button
        >
        <md-button
          :disabled="!formTouched"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >Opslaan</md-button
        >
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import swal from "sweetalert2";
export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      boolean: null,
      requesting: false,
      startDate: null,
      stopDate: null,
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0,
      sunday: 0,
      touched: {
        startDate: false,
        stopDate: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false
      },
      submitErrors: ""
    };
  },
  methods: {
    init() {
      this.$material.locale.dateFormat = "dd-MM-yyyy";
      this.$material.locale.firstDayOfAWeek = 1;
      this.$material.locale.days = [
        "Zondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrijdag",
        "Zaterdag"
      ];
      this.$material.locale.shortDays = [
        "Zon",
        "Maa",
        "Din",
        "Woe",
        "Don",
        "Vri",
        "Zat"
      ];
      this.$material.locale.shorterDays = ["Z", "M", "D", "W", "D", "V", "Z"];
      this.$material.locale.months = [
        "Januari",
        "Februari",
        "Maart",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "December"
      ];
      this.$material.locale.shortMonths = [
        "Jan",
        "Feb",
        "Mrt",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dec"
      ];
      this.$material.locale.shorterMonths = [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
      ];

      if (this.$route.params.id !== undefined) {
        this.loadRoutePeriod(this.$route.params.id);
      } else {
        this.startDate = null;
        this.stopDate = null;
        this.monday = 0;
        this.tuesday = 0;
        this.wednesday = 0;
        this.thursday = 0;
        this.friday = 0;
        this.saturday = 0;
        this.sunday = 0;

        setTimeout(this.resetTouched, 100);
      }
    },
    validate() {
      this.$http
        .post(
          this.$apiBaseUrl +
            "routes/period/" +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            route_id: this.$route.params.routeId,
            startDate: this.formatDateBack(this.startDate),
            stopDate: this.formatDateBack(this.stopDate),
            monday: this.monday ? 1 : 0,
            tuesday: this.tuesday ? 1 : 0,
            wednesday: this.wednesday ? 1 : 0,
            thursday: this.thursday ? 1 : 0,
            friday: this.friday ? 1 : 0,
            saturday: this.saturday ? 1 : 0,
            sunday: this.sunday ? 1 : 0
          })
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Route periode succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan route",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    formatDateBack(date) {
      if (typeof date !== "string" || date === "") {
        return null;
      }
      date = date.split("-");
      if (date[2].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    loadRoutePeriod(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "routes/period/" + id).then(
        response => {
          this.startDate = this.formatDate(response.data.routePeriod.startDate);
          this.stopDate = this.formatDate(response.data.routePeriod.stopDate);
          this.monday = !!response.data.routePeriod.monday;
          this.tuesday = !!response.data.routePeriod.tuesday;
          this.wednesday = !!response.data.routePeriod.wednesday;
          this.thursday = !!response.data.routePeriod.thursday;
          this.friday = !!response.data.routePeriod.friday;
          this.saturday = !!response.data.routePeriod.saturday;
          this.sunday = !!response.data.routePeriod.sunday;

          setTimeout(this.resetTouched, 100);

          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van routes", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadRoutesGroups() {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "routes/groups").then(
        response => {
          this.groups = response.data.routeGroups;
          this.requesting = false;
          setTimeout(this.resetTouched, 100);
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van routes", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    resetTouched() {
      this.touched.startDate = false;
      this.touched.stopDate = false;
      this.touched.monday = false;
      this.touched.tuesday = false;
      this.touched.wednesday = false;
      this.touched.thursday = false;
      this.touched.friday = false;
      this.touched.saturday = false;
      this.touched.sunday = false;
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    inArray(haystack, needle) {
      for (var i in haystack) {
        if (haystack[i] === needle) {
          return true;
        }
      }

      return false;
    }
  },
  watch: {
    startDate() {
      if (!this.requesting) {
        this.touched.startDate = true;
      }
    },
    stopDate() {
      if (!this.requesting) {
        this.touched.stopDate = true;
      }
    },
    monday() {
      if (!this.requesting) {
        this.touched.monday = true;
      }
    },
    tuesday() {
      if (!this.requesting) {
        this.touched.tuesday = true;
      }
    },
    wednesday() {
      if (!this.requesting) {
        this.touched.wednesday = true;
      }
    },
    thursday() {
      if (!this.requesting) {
        this.touched.thursday = true;
      }
    },
    friday() {
      if (!this.requesting) {
        this.touched.friday = true;
      }
    },
    saturday() {
      if (!this.requesting) {
        this.touched.saturday = true;
      }
    },
    sunday() {
      if (!this.requesting) {
        this.touched.sunday = true;
      }
    },
    $route(to, from) {
      this.init();
    }
  },
  computed: {
    title: function() {
      if (this.$route.params.id !== undefined) {
        return "Route periode bewerken";
      }
      return "Route periode toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "directions_bus";
      }
      return "directions_bus";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
.md-card-content > span > .md-field.md-datepicker {
  padding-top: 15px;
  &:after {
    bottom: 20px;
  }
}
</style>
<style lang="scss">
.md-inline-checkboxes .md-checkbox .md-checkbox-label {
  line-height: 6px !important;
}
</style>
